function typeId(type) {
  if (type && typeof type === 'object') return type.id;
  return type;
}

function typeName(type) {
  if (type && typeof type === 'object') return type.name;
  return type;
}

export function customerTypeIds(client) {
  if (Array.isArray(client?.customer_types)) {
    return client.customer_types
      .map(typeId)
      .filter((id) => id !== null && id !== undefined && id !== '')
      .map(String);
  }
  const one = client?.customer_type;
  if (one && typeof one === 'object' && one.id != null) return [String(one.id)];
  if (client?.customer_type_id != null && client.customer_type_id !== '') {
    return [String(client.customer_type_id)];
  }
  return [];
}

export function customerTypeLabel(client, empty = '-') {
  if (Array.isArray(client?.customer_types) && client.customer_types.length) {
    const names = client.customer_types.map(typeName).filter(Boolean);
    if (names.length) return names.join(', ');
  }
  const one = client?.customer_type;
  if (one && typeof one === 'object') return one.name || empty;
  return one || empty;
}
